import React from 'react';
import Marazone from '../../components/Marazone/Marazone';

const MarazonPage = () => {
    return (
        <div>
            <div className='text-center mt-8 mb-8 text-2xl font-bold'>마라존</div>
            <hr  className=' ml-28 mr-28'/>
            <Marazone/>
        </div>
    );
};

export default MarazonPage;